import { useUserStore } from '@/config/store/userStore'
import { isCurrentJobActive } from '@/services/resource'

const canUserAccessChat = (user: any) => {
  if (!user?._firmId) return false
  // Candidates / pre-onboarding (no active job) must not access chat
  if (!isCurrentJobActive(user.currentJob)) return false
  // Default on when profile.chat is missing (P0); honor explicit false
  if (user.profile?.modules?.chat?.isAccess === false) return false
  return true
}

export const guardChatAccess = () => {
  const userStore = useUserStore()
  const canAccess = canUserAccessChat(userStore.user)
  return canAccess || { name: 'Home' }
}

export { canUserAccessChat }
